import {Dispatch, SetStateAction} from 'react'
import {RequiredOptions, StickerSettingsInBoard, Tag} from 'yougile-model'
import {UseCommonHandlerType} from '@components/sticker/my-stickers/board-stickers/sticker-settings/types'

export const noDefaultState = 'no-default-state'
export const userDefaultState = ['author']

export const useCommonHandlers = <T extends string | string[]>(
  sticker: Tag,
  setState: Dispatch<SetStateAction<StickerSettingsInBoard>>
): UseCommonHandlerType<T> => {
  const toggleHasDefaultState = (): void => {
    const type = String(sticker.properties.stickerType)
    if (!['string', 'sprint', 'user', 'stopwatch', 'deadline'].includes(type)) {
      return
    }

    setState(state => {
      const newState = {...state}
      const hasDefaultState = !state?.hasDefaultState
      if (hasDefaultState) {
        const defaultState = type === 'user' ? userDefaultState : noDefaultState
        newState.hasDefaultState = true
        newState.defaultState = defaultState
      } else {
        newState.hasDefaultState = false
        delete newState.defaultState
      }
      return newState
    })
  }

  const toggleRequired = (required: RequiredOptions): void =>
    setState(state => ({...state, required}))

  const onDefaultStateChanged = (defaultState: T): void =>
    setState(state => ({...state, defaultState}))

  return {toggleHasDefaultState, toggleRequired, onDefaultStateChanged}
}
